import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { useAdminLoginMutation } from '../../store/api';
import { useAppDispatch } from '../../hooks/redux';
import { setAuth } from '../../store/authSlice';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [adminLogin, { isLoading, isError, error }] = useAdminLoginMutation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const response = await adminLogin({ email, password }).unwrap();

      // Store auth info in Redux state
      dispatch(
        setAuth({
          user: response.user,
          account: response.account,
        }),
      );

      // Navigate to dashboard or main app
      navigate('/dashboard');
      console.log('Login successful:', response);
    } catch (err) {
      console.error('Login failed:', err);
    }
  };

  let errMsg = 'An unexpected error occurred';
  if (error) {
    if ('status' in error) {
      console.log('error', error);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      errMsg = 'data' in error ? error.data?.error?.message : JSON.stringify(error.data);
      console.log('here');
    } else errMsg = error.message ?? 'An unexpected error occurred';
  }

  return (
    <div className='bg-black min-h-screen flex items-center justify-center bg-background p-4'>
      <Card className='w-full max-w-md bg-gray-800'>
        <CardHeader className='space-y-1'>
          <CardTitle className='text-2xl font-bold text-center'>Hainok Admin</CardTitle>
          <CardDescription className='text-center text-gray-300'>
            Enter your credentials to access your account
          </CardDescription>
        </CardHeader>
        <CardContent>
          {isError && <div className='text-red-500 text-center mb-4'>{errMsg}</div>}
          <form onSubmit={handleSubmit} className='space-y-4'>
            <div className='space-y-2'>
              <Label htmlFor='email'>Email address</Label>
              <Input
                id='email'
                type='email'
                placeholder='Enter your email'
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                required
                autoComplete='email'
                className='bg-black'
                disabled={isLoading}
              />
            </div>
            <div className='space-y-2'>
              <Label htmlFor='password'>Password</Label>
              <Input
                id='password'
                type='password'
                placeholder='Enter your password'
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                required
                autoComplete='current-password'
                className='bg-black'
                disabled={isLoading}
              />
            </div>
            <Button type='submit' className='w-full cursor-pointer' disabled={isLoading}>
              {isLoading ? 'Signing in...' : 'Sign in'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
